import axios from 'axios';
import { setAlert } from './alert';
import { alertErrorDispatch } from './app';
import {
    USER_LOADED,
    GET_ATTENDEE_ME,
    UPDATE_ATTENDEE_ME,
    ATTENDEE_ERROR,
    UPDATE_ATTENDEE_ERROR,
    TOGGLE_MY_ATTENDEE_ACTIVE_STATUS,
    GET_ALL_ATTENDEES_EDIT,
    TOGGLE_ATTENDEE_ACTIVE_STATUS,
    TOGGLE_ATTENDEE_ADMIN_ACTIVE_STATUS,
} from './types';
import { getNotifications } from './notification';

// Get current attendee's profile
export const getCurrentAttendee = () => async (dispatch) => {
    try {
        const res = await axios.get(`/api/attendees/me`);
        dispatch({
            type: GET_ATTENDEE_ME,
            payload: res.data,
        });
    } catch (err) {
        dispatch({
            type: ATTENDEE_ERROR,
            payload: {
                msg: err.response?.statusText,
                status: err.response?.status,
            },
        });
    }
};

// Create or update attendee
export const createMyAttendee =
    (formData, edit = false) =>
    async (dispatch) => {
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            const formDataArray = [formData];
            const res = await axios.post(
                '/api/attendees/updateMe',
                formDataArray,
                config
            );
            dispatch({
                type: UPDATE_ATTENDEE_ME,
                payload: res.data.attendee,
            });
            dispatch({
                type: USER_LOADED,
                payload: res.data.user,
            });
            dispatch(getNotifications());
        } catch (err) {
            const errors = err.response?.data?.errors;
            if (errors) {
                errors.forEach((error) =>
                    dispatch(setAlert(error.msg, 'danger'))
                );
            }
            dispatch({
                type: UPDATE_ATTENDEE_ERROR,
                payload: {
                    msg: err.response?.statusText,
                    status: err.response?.status,
                },
            });
            dispatch(alertErrorDispatch(err));
        }
    };

// Toggle Attendee active status and notificationFrequency
export const toggleMyAttendeeActiveStatus = (formData) => async (dispatch) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        const res = await axios.post(
            '/api/attendees/toggleMyActivation',
            formData,
            config
        );
        dispatch({
            type: TOGGLE_MY_ATTENDEE_ACTIVE_STATUS,
            payload: res.data.attendee,
        });
    } catch (err) {
        const errors = err.response?.data?.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: UPDATE_ATTENDEE_ERROR,
            payload: {
                msg: err.response?.statusText,
                status: err.response?.status,
            },
        });
        dispatch(alertErrorDispatch(err));
    }
};

export const getAllAttendees = () => async (dispatch) => {
    try {
        const res = await axios.get('/api/attendees/edit');
        dispatch({
            type: GET_ALL_ATTENDEES_EDIT,
            payload: res.data,
        });
    } catch (err) {
        dispatch({
            type: ATTENDEE_ERROR,
            payload: {
                msg: err.response?.statusText,
                status: err.response?.status,
            },
        });
    }
};

export const toggleAttendeeActiveStatus = (formData) => async (dispatch) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        const formDataArray = [formData];
        const res = await axios.post(
            '/api/attendees/updateMe',
            formDataArray,
            config
        );
        dispatch({
            type: TOGGLE_ATTENDEE_ACTIVE_STATUS,
            payload: res.data.attendee,
        });
    } catch (err) {
        const errors = err.response?.data?.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: UPDATE_ATTENDEE_ERROR,
            payload: {
                msg: err.response?.statusText,
                status: err.response?.status,
            },
        });
        dispatch(alertErrorDispatch(err));
    }
};

export const toggleAttendeeAdminActiveStatus = (formData) => async (dispatch) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        const formDataArray = [formData];
        const res = await axios.post(
            '/api/attendees/updateMe',
            formDataArray,
            config
        );
        dispatch({
            type: TOGGLE_ATTENDEE_ADMIN_ACTIVE_STATUS,
            payload: res.data.attendee,
        });
    } catch (err) {
        const errors = err.response?.data?.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: UPDATE_ATTENDEE_ERROR,
            payload: {
                msg: err.response?.statusText,
                status: err.response?.status,
            },
        });
        dispatch(alertErrorDispatch(err));
    }
};

export const updateEventDiscoveryRadius =
    (miles) => async (dispatch, getState) => {
        try {
            const state = getState();
            const email = state.attendee?.me?.email || state.auth?.user?.email;
            if (!email) return;
            const radius = Math.min(Math.max(Number(miles) || 40, 1), 500);
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            const res = await axios.post(
                '/api/attendees/updateMe',
                [{ email, eventDiscoveryRadius: radius }],
                config
            );
            dispatch({
                type: UPDATE_ATTENDEE_ME,
                payload: res.data.attendee,
            });
            return res.data.attendee;
        } catch (err) {
            dispatch({
                type: UPDATE_ATTENDEE_ERROR,
                payload: {
                    msg: err.response?.statusText,
                    status: err.response?.status,
                },
            });
            dispatch(alertErrorDispatch(err));
        }
    };
